export default __webpack_public_path__ + "static/media/character-right.b53ae50b.png";